// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "-legacy." + {"112":"25f4cfba","220":"c26c3b4a","839":"acfc4206"}[chunkId] + ".js";
};